var paragraph_default = {
  "fontElementMap": "u-HEo",
  "elementSpacing": "aaZkV",
  "text": "Is4xI aaZkV",
  "child": "vsfWl"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
